import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";

const LeadContactFormDialog = ({ open, onClose, onSubmit, initialData, saving }) => {
  const [mobile, setMobile] = useState("");
  const [submitError, setSubmitError] = useState("");

  useEffect(() => {
    if (!open) return;
    setSubmitError("");
    setMobile(initialData?.mobile || initialData?.normalizedMobile || "");
  }, [open, initialData]);

  const handleSubmit = async () => {
    if (!mobile?.trim()) {
      setSubmitError("شماره موبایل الزامی است.");
      return;
    }
    const result = await onSubmit({ mobile: mobile.trim() });
    if (result?.error) setSubmitError(result.error);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>ویرایش شماره موبایل</DialogTitle>
      <DialogContent>
        <TextField
          label="شماره موبایل"
          fullWidth
          required
          autoFocus
          placeholder="09123456789"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
          error={Boolean(submitError)}
          helperText={submitError || "فرمت: 09xxxxxxxxx"}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          انصراف
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={saving}>
          {saving ? "در حال ذخیره..." : "ذخیره"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeadContactFormDialog;
